import { ENUM_DATE_RANGE } from '@cokitchen/cokitchen-components';

export enum ENUM_REQUEST_STATUS {
  PENDING = 'PENDING',
  SENT = 'SENT',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED',
  COMPLETED = 'COMPLETED',
  CREATED = 'CREATED',
  RECEIVED = 'RECEIVED',
  APPROVED = 'APPROVED',
  REVIEWED = 'REVIEWED',
  RETURNED = 'RETURNED',
  PAID = 'PAID',
  CANCELLED = 'CANCELLED',
  OPEN = 'OPEN'
}

export enum ENUM_PAYMENT_STATUS {
  PENDING = 'PENDING',
  OUTSTANDING = 'OUTSTANDING',
  COMPLETED = 'COMPLETED',
  REQUESTED = 'REQUESTED',
  APPROVED = 'APPROVED',
  PAID = 'PAID',
  REJECTED = 'REJECTED'
}

export enum ENUM_BASE_MEALS_STATUS {
  MAPPED = 'MAPPED',
  UNMAPPED = 'UNMAPPED',
  ALL = 'ALL'
}

export enum ENUM_RETURNS_STATUS {
  CREATED = 'CREATED',
  COMPLETED = 'COMPLETED'
}

export enum ENUM_MEAL_STATUS {
  AVAILABLE = 'Available',
  SOLD_OUT = 'Sold out'
}
export enum ENUM_UNIT {
  KG = 'kg',
  G = 'g',
  UNIT = 'unit',
  GRAM = 'gram',
  PORTION = 'portion',
  PACK = 'pack',
  PCS = 'pcs'
}

export type DATE_RANGE_TYPE = { startDate: Date; endDate: Date; range: ENUM_DATE_RANGE };

export type DROP_DOWN_OPTIONS_TYPE = { text: string; value: string };
